import React from 'react'
import { UiCol, UiRowContainer } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,
    UiContentCol,
    UiContentWheelCol,
    UiTabContentWr

} from "../../components/common/UiPageElements";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import Footer from "../../components/footer/Footer";
import UiHowCampaignsWork from ".././../components/common/UiHowCampaignsWork";
import IncentiveBanner from './views/IncentiveBanner';
import nyImage from "../../../../styles/img/spin-win-1.jpg";
import nyImage2 from "../../../../styles/img/spin-win-2.jpg";
import nyImage3 from "../../../../styles/img/spin-win-3.jpg";
import nyImage4 from "../../../../styles/img/spin-win-4.jpg";
import { Button } from "react-bootstrap";
import { UiCardTitle } from '../../components/common/UiCardTitle';
import { UiBannerBottomBar } from "../../../_uiMocks/components/common/UiBannerBottomBar";
import { TripFeatures } from './views/TripFeatures';
import { HowIncentiveWorks } from './views/HowIncentiveWorks';
import { TermsConditions } from './views/TermsConditions';
import { Faq } from './views/Faq';
import spinBanner from "../../../../styles/img/spin-win-banner.jpg";
import { TickIcon } from '../../../../styles/img/svg/TickIcon';
import { UiLeftContentRightImageBlock } from '../../components/common/UiImageBlock';
import SpinAndWheel from './views/SpinAndWheel';
import { UiScrollNavWr, UiScrollNavItem } from "../../components/common/UiScrollToElements"
import { Accordion } from "react-bootstrap";
import { UiAccordion } from '../../components/common/UiAccordion';
import SpinWinImage from "../../../../styles/img/spin-win-image.png"
import ToyotaLogo from "../../../../styles/img/toyota-logo.png"

export const IncentiveSpinWin = (props) => {

    const wizardData = [
        { id: 1,number:"1", title: 'Step 1', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.',status:'active' },
        { id: 2,number:"2", title: 'Step 2', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.'},
        { id: 3,number:"3", title: 'Step 3', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.'},
        { id: 3,number:"4", title: 'Step 4', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.'},
        { id: 5,number:<TickIcon />, title: 'Success', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.',status:"success" },
    ];

    const termsConditions = [
        {
            id: 1,
            title: 'Trip to New York!',
            image1:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',
            image2:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',
            image3:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',
            image4:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 2,
            title: 'How many do I need to sell?',
            image1:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 3,
            title: 'Duis enim bibendum dui ut fringilla suspendisse vel sed ultricies',
            image1:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',

            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 4,
            title: 'Duis enim bibendum dui ut fringilla suspendisse vel sed ultricies',
            image1:'https://cdn.pixabay.com/photo/2015/03/11/12/31/buildings-668616_1280.jpg',

            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
       
    ]

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveBanner
                    topText="Incentive"
                    title="Race Around the World"
                    description="How far will you go?"
                    SpinWinImage
                    brandlogo={ToyotaLogo}
                   
                />

                <UiBannerBottomBar
                    prevPage="Campaigns"
                    prevPageLink="/ui"
                    currentPage="Sell 15 Premium Tickets"
                    currentPageLink="/ui/incentives-pre-register"
                />


                <UiContentWr>
                    <UiTabContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiScrollNavWr>
                                <UiScrollNavItem hash="How-to-participate" hashText="How to participate" />
                                <UiScrollNavItem hash="Play-the-game" hashText="Play the game" />
                                <UiScrollNavItem hash="T-and-Cs" hashText="Terms and conditions" />                            
                            </UiScrollNavWr>
                        </UiRowContainer>
                    </UiTabContentWr>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                            <div className='sb-incentive-leauge'>
                                 <UiAccordion items={termsConditions} defaultActiveKey/>
                            </div>
                           
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <div id="How-to-participate"></div>
                <HowIncentiveWorks wizardData={wizardData} />

                <div id="Play-the-game"></div>
                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentWheelCol>
                                <SpinAndWheel spinAndWheel={true}/>
                            </UiContentWheelCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <div id="T-and-Cs"></div>
                <TermsConditions />
                <Faq />
                <Footer />
            </UiMainWrapper>
        </>
    )
}



